<template lang="pug">
  tbody
    tr
      th(colspan=2) {{ slots_title }}
      td
        PTSelect(
          ref="slots_upline_pt"
          :dirty="$v.slots_upline_pt.$dirty"
          :error="$v.slots_upline_pt.$error"
          :options="slots_upline_options"
          :value="slots_upline_pt"
          @input="input_slots_upline_pt"
          :disabled="loading"
        )
      td(v-show="isSearch")
        PTSelect(
          ref="slots_account_pt"
          :dirty="$v.slots_account_pt.$dirty"
          :error="$v.slots_account_pt.$error"
          :options="slots_account_options"
          :value="slots_account_pt"
          @input="input_slots_account_pt"
          :disabled="loading"
        )
      td(v-show="isSearch")
        PTSelect(
          ref="slots_upline_remaining"
          :dirty="$v.slots_upline_remaining.$dirty"
          :error="$v.slots_upline_remaining.$error"
          :options="slots_account_options"
          :value="slots_upline_remaining"
          @input="$v.slots_upline_remaining.$model = $event"
          :disabled="loading"
        )
      td(v-show="isSearch")
        PTSelect(
          ref="slots_account_min"
          :dirty="$v.slots_account_min.$dirty"
          :error="$v.slots_account_min.$error"
          :options="slots_min_options"
          :value="slots_account_min"
          @input="$v.slots_account_min.$model = $event"
          :disabled="loading"
        )
</template>

<script>
import { required, minValue } from "vuelidate/lib/validators";
import PTSelect from "@/library/PTSelect";

export default {
  components: {
    PTSelect
  },
  props: {
    loading: false,
    accountID: ""
  },
  data() {
    return {
      slots_upline_pt: 0,
      slots_account_pt: 0,
      slots_upline_remaining: 0,
      slots_account_min: 0
    }
  },
  validations() {
    return {
      slots_upline_pt: {
        required,
        minValue(value) {
          if(this.$helpers.isPlatformEnabled('SL')) {
            let total = 0
            if(this.$helpers.isAgentLevel()) {
              total = value
            } else {
              total = value + this.slots_account_pt
            }
            if(total < this.slots_upline_min) {
              return false
            } else {
              return true
            }
          } else {
            return true
          }
        }
      },
      slots_account_pt: {
        required,
        minValue(value) {
          if(this.$helpers.isPlatformEnabled('SL')) {
            let total = 0
            if(this.$helpers.isAgentLevel()) {
              return true
            } else {
              total = value + this.slots_upline_pt
              if(total < this.slots_upline_min) {
                return false
              } else {
                return true
              }
            }
          } else {
            return true
          }
        }
      },
      slots_upline_remaining: {
        required
      },
      slots_account_min: {
        required
      }
    }
  },
  computed: {
    isSearch: function() {
      if(this.accountID) {
        return !(this.accountID.length > 8)
      } else {
        return !this.$helpers.isAgentLevel()
      }
    },
    slots_title: function () {
      return this.$t("ui.slot_games") + " (" + this.slots_upline_min + "%-" + this.slots_upline_max + "%)"
    },
    slots_upline_min: function() {
      return this.$store.getters.getPTSL[0].account_min
    },
    slots_upline_max: function() {
      return this.$store.getters.getPTSL[0].account_pt
    },
    slots_account_max: function() {
      return this.slots_upline_max - this.slots_upline_pt
    },
    slots_upline_options: function() {
      return this.$helpers.getPTRateList(this.slots_upline_max)
    },
    slots_account_options: function() {
      return this.$helpers.getPTRateList(this.slots_account_max)
    },
    slots_min_options: function() {
      return this.$helpers.getPTRateList(this.slots_account_pt)
    }
  },
  mounted: function() {
    if(this.$helpers.isAgentLevel()) {
      this.$v.slots_upline_pt.$model = this.slots_upline_max
    }
    if(!this.$helpers.isPlatformEnabled('SL')) {
      this.$v.slots_upline_pt.$model = this.slots_upline_min
    }
  },
  methods: {
    input_slots_upline_pt(e) {
      this.$v.slots_upline_pt.$model = e
      this.$v.slots_account_pt.$model = this.slots_account_max

      if (this.slots_upline_remaining > this.slots_account_max) {
        this.$v.slots_upline_remaining.$model = 0
      }
      if (this.slots_account_min > this.slots_account_pt) {
        this.$v.slots_account_min.$model = 0
      }
    },
    input_slots_account_pt(e) {
      this.$v.slots_account_pt.$model = e
      if (this.slots_account_min > this.slots_account_pt) {
        this.$v.slots_account_min.$model = 0
      }
    }
  }
}

</script>